import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Resumen } from '../../../modelos/modelo-resumen';
import { ResumenService } from '../../../services/resumen.service';

// import { MatStepper } from '@angular/material';

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css'],
})
export class FormularioComponent implements OnInit {

  isLinear = false;
  // resumenFG: FormGroup;
  // firstFormGroup: FormGroup;
  // secondFormGroup: FormGroup;
  resumen: Resumen = new Resumen();
  submitted = false;

  // /*
  resumenForm = this.fb.group({
    titulo: [null, Validators.compose([
      Validators.required,  Validators.maxLength(100)])],
    autores: [null, Validators.required],
    filiacion: [null, Validators.required],
    introducion: [null, Validators.compose([
      Validators.required,  Validators.maxLength(1100)])],
    objetivo: [null, Validators.compose([
      Validators.required,  Validators.maxLength(500)])],
    metodo: [null, Validators.compose([
      Validators.required,  Validators.maxLength(650)])],
    resultados: [null, Validators.compose([
      Validators.required,  Validators.maxLength(1400)])],
    conclusion: [null, Validators.compose([
      Validators.required,  Validators.maxLength(750)])],
    palabrasclaves: [null, Validators.required],
    nombreresponsable: [null, Validators.required],
    emailresponsable: [null, Validators.required]
  });
  // */

  constructor(private fb: FormBuilder, private resumenService: ResumenService, private router: Router) {}
  // constructor(private resumenService: ResumenService) {}
 /*
  ngOnInit() {
    this.resumenForm = this.fb.group({
      firstCtrl: ['', Validators.required];
      secondCtrl: ['', Validators.required]
    });
    this.firstFormGroup = this.fb.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this.fb.group({
      secondCtrl: ['', Validators.required]
    });
  }
*/
    ngOnInit() {
    }

    newResumen(): void {
      this.submitted = false;
      this.resumen = new Resumen();
    }
    save() {
      this.resumenService.createResumen(this.resumen);
      this.resumen = new Resumen();
    }

    onSubmit() {
      alert('Thanks!');
      console.log(this.resumen);
    }

    onEnviar() {
      // console.log(this.resumen);
      // console.log(this.resumenForm);

         this.resumen.titulo = this.resumenForm.value.titulo;
         this.resumen.autores = this.resumenForm.value.autores;
         this.resumen.filacion = this.resumenForm.value.filiacion;
         this.resumen.introducion = this.resumenForm.value.introducion;
         this.resumen.objetivo = this.resumenForm.value.objetivo;
         this.resumen.metodo = this.resumenForm.value.metodo;
         this.resumen.resultados = this.resumenForm.value.resultados;
         this.resumen.conclusion = this.resumenForm.value.conclusion;
         this.resumen.palabrasclaves = this.resumenForm.value.palabrasclaves;
         this.resumen.nombreresponsable = this.resumenForm.value.nombreresponsable;
         this.resumen.emailresponsable = this.resumenForm.value.emailresponsable;

         console.log('Si se puede en onEnviar');
         console.log(this.resumenForm.valid);
         console.log(this.resumenForm);


      if (this.resumenForm.valid) {
         this.submitted = true;
         this.save();
         alert(JSON.stringify('Felicidades, el resumen fue enviado con éxito!'));
         this.router.navigate(['dash']);
      } else {
        alert(JSON.stringify('Por favor complete el formulario para ser enviado.'));
        this.submitted = false;
      }
    }
}
